/* ============================================================
   COMICS.JS — Page-specific scripts for comics.html
   ============================================================ */

// ===== STATS COUNT-UP (no animation dependency) =====

document.querySelectorAll('.tv-stats .stat-val').forEach(el=>{
  const target=parseInt(el.dataset.count);
  if(typeof ScrollTrigger!=='undefined'){
    ScrollTrigger.create({
      trigger:'.tv-stats',start:'top 80%',once:true,
      onEnter:()=>{
        gsap.to({v:0},{v:target,duration:1.2,ease:'power2.out',
          onUpdate:function(){
            const val=Math.round(this.targets()[0].v);
            el.textContent=val>=1000?val.toLocaleString():val;
          }
        });
      }
    });
  } else {
    el.textContent=target>=1000?target.toLocaleString():target;
  }
});
